import MicroModal from 'micromodal';

document.addEventListener('DOMContentLoaded', () => {
	const config = {
		onShow: modal => {
			document.querySelector('body').classList.add('modal-open');
		},
		onClose: modal => {
			document.querySelector('body').classList.remove('modal-open');
		},
		openTrigger: 'data-micromodal-trigger',
		closeTrigger: 'data-micromodal-close',
		openClass: 'is-open',
		disableScroll: true,
	};

	// MicroModal.init(config);

	window.showModal = (strId) => {
		MicroModal.show(strId, config);
	};

	window.closeModal = (strId) => {
		MicroModal.close(strId);
	};
});

